import { render, staticRenderFns } from "./DynamicTagsFallbackSection.vue?vue&type=template&id=18dad120&scoped=true&"
import script from "./DynamicTagsFallbackSection.vue?vue&type=script&lang=js&"
export * from "./DynamicTagsFallbackSection.vue?vue&type=script&lang=js&"
import style0 from "./DynamicTagsFallbackSection.vue?vue&type=style&index=0&id=18dad120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dad120",
  null
  
)

export default component.exports